export enum EventType {
	PreRentInspection = 0,
	RoutineInspection = 10,
	EndOfTenancyInspection = 20,
	Inventory = 30,
	Maintenance = 40,
	Repair = 50,
	Clean = 60
}